export const BooleanOptions = [
  { value: true, label: 'Sí' },
  { value: false, label: 'No' },
]
